export default __webpack_public_path__ + "static/media/backgroundVideoExchangeLG.7feddd25.png";